/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import ParseApp          from 'lib/ParseApp';
import React             from 'react';
import PropTypes         from 'prop-types';
import styles            from 'components/PushAudiencesSelector/PushAudiencesOption.scss';
import { NEW_SEGMENT_ID} from 'dashboard/Push/PushConstants';

export default class PushAudiencesBaseRow extends React.Component {
  constructor() {
    super();
    this.xhrHandle = null;
    this.state = {
      count: undefined,
      expandedView: false,
      approximate: false,
      isNewSegment: false,
    }
  }

  componentWillMount() {
    this.fetchPushSubscriberCount();
    if (this.props.id == NEW_SEGMENT_ID) {
      this.setState({ isNewSegment: true });
    }
  }

  componentWillReceiveProps(props, context) {
    if (this.context !== context) {
      this.fetchPushSubscriberCount();
    }
  }

  componentWillUnmount() {
    if (this.xhrHandle) {
      this.xhrHandle.abort();
    }
  }

  fetchPushSubscriberCount() {
    return this.context.currentApp.fetchPushSubscriberCount(this.props.id, this.props.query).then((count) => {
      this.setState({ count });
    });
  }

  handleDetailsToggle(query, schema, evt) {
    evt.preventDefault();

    this.setState({
      expandedView : !this.state.expandedView
    });
  }
}

PushAudiencesBaseRow.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};
